import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const valuationAC: CriterionType[] = [
  {
    id: 'VAL-10',
    label: 'P/E normalized',
    shortLabel: 'P/E Norm',
    group: AC_GROUPS.valuation,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'VAL-20',
    label: 'P/E incl. extraordinary items',
    shortLabel: 'P/E InclXOI',
    group: AC_GROUPS.valuation,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'VAL-30',
    label: 'P/E excl. extraordinary items',
    shortLabel: 'P/E ExclXOI',
    group: AC_GROUPS.valuation,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'VAL-40',
    label: 'Price to book',
    shortLabel: 'P/B',
    group: AC_GROUPS.valuation,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'VAL-50',
    label: 'Price to tangible book',
    shortLabel: 'P/TB',
    group: AC_GROUPS.valuation,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'VAL-60',
    label: 'Price to cash flow per share',
    shortLabel: 'P/CF',
    group: AC_GROUPS.valuation,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'VAL-70',
    label: 'Price to free cash flow per share',
    shortLabel: 'P/FCF',
    group: AC_GROUPS.valuation,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'VAL-80',
    label: 'Price to equity',
    shortLabel: 'P/Equity',
    group: AC_GROUPS.valuation,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'VAL-90',
    label: 'Price to sales',
    shortLabel: 'P/S',
    group: AC_GROUPS.valuation,
    type: AC_TYPES.normal,
    withRange: true,
  },
];

export default valuationAC;
